/**
 * A translucent card-colored wash laid over a past event so its colour fades
 * toward the panel background (theme-correct: lighter in light mode, darker in
 * dark mode) WITHOUT making the block see-through to whatever is behind it.
 * The parent must be `relative` (and ideally clip overflow for rounded corners).
 */
export function FaintOverlay() {
  return <div className="pointer-events-none absolute inset-0 z-[1] bg-card/60" aria-hidden />;
}
